import type { GuaranteeItem, ValidationItem, ReceivableItem, GuaranteeTitleItem } from './collateralUtils';
import guaranteesMock from './mock/guarantees-mock.json';
import validationMock from './validation-mock-data.json';
import receivablesMock from './mock/receivables-mock.json';
import titlesMock from './mock/guarantee-titles-mock.json';

let guarantees: GuaranteeItem[] = [...guaranteesMock] as GuaranteeItem[];
let validations: ValidationItem[] = validationMock.map(v => ({
    ...v,
    operationId: v.operation_id,
    assignorCnpj: '',
    amountPayed: v.amount_payed,
    percentagePayed: v.percentage_payed,
    percentageValidated: v.percentage_validated,
    totalTitulos: v.total_titulos,
    totalPayer: v.total_payer,
})) as ValidationItem[];
let receivables: ReceivableItem[] = [...receivablesMock] as ReceivableItem[];
let guaranteeTitles: GuaranteeTitleItem[] = [...titlesMock] as GuaranteeTitleItem[];

// Tag colors
let tagColors: Record<string, string> = {};

// --- Guarantees ---
export const getGuarantees = (): GuaranteeItem[] => guarantees;

export const updateGuarantee = (id: number, updates: Partial<GuaranteeItem>): void => {
    const idx = guarantees.findIndex(g => g.id === id);
    if (idx !== -1) guarantees[idx] = { ...guarantees[idx], ...updates };
};

export const addGuarantee = (item: GuaranteeItem): void => {
    guarantees = [item, ...guarantees];
};

// --- Validations ---
export const getValidations = (): ValidationItem[] => validations;

export const updateValidation = (id: number, updates: Partial<ValidationItem>): void => {
    const idx = validations.findIndex(v => v.id === id);
    if (idx !== -1) validations[idx] = { ...validations[idx], ...updates };
};

export const addValidation = (item: ValidationItem): void => {
    validations = [item, ...validations];
};

// --- Receivables ---
export const getReceivables = (validationId?: number): ReceivableItem[] =>
    validationId != null ? receivables.filter(r => r.validationId === validationId) : receivables;

export const updateReceivable = (id: number, updates: Partial<ReceivableItem>): void => {
    const idx = receivables.findIndex(r => r.id === id);
    if (idx !== -1) receivables[idx] = { ...receivables[idx], ...updates };
};

// --- Tag colors (shared) ---
export const getTagColor = (tag: string): string => tagColors[tag] || 'blue';
export const setTagColor = (tag: string, color: string): void => { tagColors[tag] = color; };

// --- Guarantee Titles ---
export const getGuaranteeTitles = (guaranteeId?: number): GuaranteeTitleItem[] =>
    guaranteeId != null ? guaranteeTitles.filter(t => t.guaranteeId === guaranteeId) : guaranteeTitles;

export const updateGuaranteeTitle = (id: number, updates: Partial<GuaranteeTitleItem>): void => {
    const idx = guaranteeTitles.findIndex(t => t.id === id);
    if (idx !== -1) guaranteeTitles[idx] = { ...guaranteeTitles[idx], ...updates };
};

// Backward compatibility
export const getValidationData = (): any[] => validationMock;
